import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function OfferBar() {
  const {
    minutes,
    seconds
  } = useCountdown(15);
  return <div className="sticky top-0 z-50 w-full bg-[#FF6B35] text-black py-2 px-4 flex justify-center items-center text-xs sm:text-sm font-bold uppercase tracking-wide shadow-[0_0_15px_rgba(255,107,53,0.4)]" data-id="element-147">
      <span className="mr-2" data-id="element-148">
        🔥 La oferta termina en {minutes}:{seconds}
      </span>
      <span className="mx-2 hidden sm:inline" data-id="element-149">•</span>
      <a href="https://sistemaenfocado.com" target="_blank" rel="noopener noreferrer" className="underline decoration-black decoration-2 underline-offset-2 hover:opacity-80 transition-opacity" data-id="element-150">
        Activar oferta
      </a>
    </div>;
}